<!--
 * @Autor: zhiying Qin
 * @Date: 2025-04-09 23:32:47
 * @LastEditTime: 2025-08-13 22:44:31
-->
<template>
  <div>
    <div class="listPost">

      <div style="background: #EBF8FE; width: 100vw;padding: 10px 10px;" >
        <van-field
            v-model="queryParams.companyName"
            right-icon="search"
            placeholder="根据公司名称搜索"
            @click-right-icon="onRefresh"
        />

        <van-field
            v-model="queryParams.location"
            right-icon="search"
            placeholder="根据地址搜索"
            style="margin-top: 10px;"
            @click-right-icon="onRefresh"
        />
    </div>

    
      <div class="ui-content" style="margin-top: 16px">
        <section class="record-list">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              :immediate-check="false"
              finished-text="没有更多了"
              @load="onLoad"
              offset="20"
              error-text="请求失败，点击重新加载"
            >
              <li v-for="item in list" :key="item.index" class="li-items">
                <h2
                  style="font-size: 16px; position: relative; padding: 0px 10px"
                >
                  {{ item.companyName }}
                </h2>
                <div style="margin: 10px">
                  <div class="title">
                    {{ item.companyName }}

                    <!-- <div class="ribbon" v-if="item.companyType == 2">
                      <div class="ribbon-text">大厂</div>
                    </div> -->
                  </div>
                  <div class="items-content">
                    <p class="tag">
                      <van-tag type="primary" style="margin-right: 10px">{{
                        getPostStatus('companyScaleList', 'scale', item)
                      }}</van-tag>
                      <van-tag type="primary" style="margin-right: 10px">{{
                        getPostStatus('companyTypeList', 'companyType', item)
                      }}</van-tag>
                      <!-- <van-tag type="primary" style="margin-right: 10px">{{
                        item.graduationYear
                      }}</van-tag> -->
                    </p>

                    <ol>
                      <li>
                        <span class="label">企业类型：</span>
                        <span class="label-content" style="line-height: 16px">{{
                          getPostStatus('companyMoldList', 'companyMold', item)
                        }}</span>
                      </li>
                      <li>
                        <span class="label">行业：</span>
                        <span class="label-content">{{ item.profession }}</span>
                      </li>
                      <li>
                        <span class="label">主管部门：</span>
                        <span class="label-content">{{
                          item.manageSection
                        }}</span>
                      </li>
                      <li>
                        <span class="label">总部地址：</span>
                        <span class="label-content">{{
                          item.officeAddress
                        }}</span>
                      </li>
                      <li>
                        <span class="label">企业地址：</span>
                        <span class="label-content">{{
                          item.location
                        }}</span>
                      </li>
                      <li>
                        <span class="label">企业介绍：</span>
                        <span class="label-content">{{
                          item.introduce
                        }}</span>
                      </li>
                    </ol>
                  </div>
                  <!-- <div class="items-content-footer">
                    <van-icon
                      :name="item.isCollect ? 'star' : 'star-o'"
                      size="20"
                      :color="item.isCollect ? 'orange' : ''"
                      @click="postCollect(item)"
                    />

                    <van-button
                      type="info"
                      size="small"
                      round
                      @click="copyUrl(item.sendLink)"
                      >报考链接</van-button
                    >
                  </div> -->
                </div>
              </li>

              <!-- 加载状态提示 -->
              <template #loading>
                <div class="loading-text">加载中...</div>
              </template>
            </van-list>
          </van-pull-refresh>
        </section>
      </div>
    </div>

    <van-tabbar v-model="active">
      <van-tabbar-item icon="home-o" @click="toUrl('tool')">首页</van-tabbar-item>
      <van-tabbar-item icon="orders-o">企业名录</van-tabbar-item>
      <van-tabbar-item icon="apps-o" @click="toUrl('/intelligencePost')"
        >标准筛岗</van-tabbar-item
      >
      <van-tabbar-item icon="bookmark-o" @click="toUrl('/precisePost')"
        >智能筛岗</van-tabbar-item
      >
      <!-- <van-tabbar-item icon="setting-o" replace to="/home">重点标识</van-tabbar-item> -->
      <van-tabbar-item icon="manager-o" @click="toUrl('/myCollect')"
        >我的收藏</van-tabbar-item
      >
    </van-tabbar>
  </div>
</template>

<script>
import Vue from 'vue'
import { companyList, getDictType } from '@/api/xicaiquan'
import { Tag, List, PullRefresh, Button, Toast, Tabbar, TabbarItem  } from 'vant'
Vue.use(Tag)
Vue.use(List)
Vue.use(PullRefresh)
Vue.use(Button)
Vue.use(Tabbar)
Vue.use(TabbarItem)
export default {
  name: 'listPost',
  props: {
    type: String,
    form: Object
  },
  data () {
    return {
      list: [1, 2, 3], // 列表数据
      loading: false, // 列表加载状态
      finished: false, // 列表是否加载完成
      isLoading: false, // 下拉刷新状态
      page: 1, // 当前页码
      pageSize: 10, // 每页条数
      active: 1,
      queryParams: {
        current: 1,
        size: 10,
        companyName: ''
      },
      companyMoldList: [],
      companyScaleList: [],
      companyTypeList: [],
    }
  },
  created () {
    // if (this.type == "precisePost") {
    //   this.getPostFilter();
    // }
    // this.list = [];
    document.documentElement.scrollTop = 0
    window.pageYOffset = 0
    document.body.scrollTop = 0


    Promise.all([
        this.getDictType("company_mold", "companyMoldList"),
        this.getDictType("company_scale", "companyScaleList"),
        this.getDictType("company_company_type", "companyTypeList")
    ]).then(res => {
        this.loadData()
    })
    
    
    



  },
  components: {},
  watch: {},
  methods: {
    async getData () {
      const res1 = await companyList(this.queryParams)
      console.log('res1', res1)
      // console.log(res1);
      let data = (res1.data && res1.data.records) || []

      return data;
    },

    // 加载数据
    async loadData () {
      try {
        const data = await this.getData()
        console.log('data111', data)

        if (data) {
          // 如果是第一页，直接替换数据
          if (this.queryParams.current === 1) {
            this.list = data
          } else {
            // 否则追加数据
            this.list = [...this.list, ...data]
          }

          // 判断是否还有更多数据
          if (data.length < this.queryParams.size) {
            this.finished = true
          }
        }
      } catch (error) {
        console.error('加载数据失败:', error)
      } finally {
        this.loading = false
        this.isLoading = false
      }
    },

    // 列表滚动到底部时触发
    onLoad () {
      if (this.finished) return

      console.log('执行的。。。。。')
      this.queryParams.current++
      this.loadData()
    },

    // 下拉刷新触发
    onRefresh () {
      this.queryParams.current = 1
      this.finished = false
      this.loading = true
      this.loadData()
    },
    getPostStatus (target, prop, row) {
        
      const item = this[target].find(
        item => item.value == row[prop]
      )

      if (item) {
        return item.text 
      } else {
        return '无'
      }
    },
    async getDictType(type, target, callback) {
      return new Promise(async (resolve, reject) => {
        const res = await getDictType(type);
        if (res.code == 200) {
            resolve()
            res.data.forEach(item => {
                this[target].push({
                    text: item.dictLabel,
                    value: item.dictValue,
                });
            })
            // callback && callback(this[target]);
        } else {
            reject()
        }
      })
    },
    toUrl (path) {
      if (!path) {
        Toast('功能开发中')
        return
      }

      this.$router.replace({ path })
    }
  }
}
</script>
<style scoped lang="scss">
.listPost {
  width: 100%;
  .ui-content {
    width: 95%;
    margin: 0px auto;
    .li-items {
      border-radius: 10px;
      background: #fff;
      margin-bottom: 20px;
      h2 {
        border-bottom: 1px solid #ddd;
        line-height: 40px;
        padding: 10px;
      }

      .title {
        background: #e0edfe;
        border-radius: 10px 10px 0px 0px;
        line-height: 40px;
        font-size: 16px;
        text-indent: 20px;
        margin-top: 20px;
        position: relative;
        overflow: hidden;
        padding-right: 10px;
        text-overflow: ellipsis;
        white-space: nowrap;

        .ribbon {
          width: 80px;
          height: 40px;
          background: orange;
          position: absolute;
          top: 0;
          right: -25px;
          transform: rotate(34deg);
          transform-origin: top right;
          box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
        }

        .ribbon-text {
          position: absolute;
          top: 12px;
          right: 12px;
          color: white;
          font-weight: bold;
          font-size: 12px;
          transform: rotate(0deg);
          transform-origin: right center;
          font-family: 'Arial', sans-serif;
        }

        /* 可选：让角标右上角带圆角 */
        .ribbon::before {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          width: 12px;
          height: 12px;
          background: white;
          border-top-left-radius: 12px;
        }
      }

      .items-content {
        background: #fafbff;
        padding: 20px;
        .tag {
          display: flex;
        }

        ol {
          margin: 20px 0px;
          li {
            display: flex;
            margin: 20px 0px;
            .label {
              color: #999;
              white-space: nowrap;
              display: block;
              width: 70px;
              text-align: right;
            }
            .label-content {
                line-height: 20px;
                flex: 1
            }
          }
        }
      }

      .items-content-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid #ddd;
        padding: 14px 10px;
        background: #fafbff;
      }
    }
  }
}
</style>
